import { Dropdown } from "@components"
import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import classNames from "classnames"
import { PopupButton } from "react-calendly"

export const ResourcePlan = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  const [selected, setSelected] = React.useState<
    "senior" | "mid-level" | "both"
  >("senior")
  const [selectedItems, setSelectedItems] = React.useState({
    senior: {
      duration: "",
      numberOfResources: "",
      resourcesCategory: [{ id: "", name: "" }],
      totalPrice: 0,
    },
    midLevel: {
      duration: "",
      numberOfResources: "",
      resourcesCategory: [{ id: "", name: "" }],
      totalPrice: 0,
    },
  })
  const [selectedIds, setSelectedIds] = React.useState<string[]>([])

  const durationOptions = [
    { id: "1", name: "1 Month", value: 1 },
    { id: "2", name: "2 Months", value: 2 },
    { id: "3", name: "3 Months", value: 3 },
    { id: "4", name: "4 Months", value: 4 },
    { id: "5", name: "5 Months", value: 5 },
    { id: "6", name: "6 Months", value: 6 },
    { id: "7", name: "7 Months", value: 7 },
    { id: "8", name: "8 Months", value: 8 },
    { id: "9", name: "9 Months", value: 9 },
    { id: "10", name: "10 Months", value: 10 },
    { id: "11", name: "11 Months", value: 11 },
    { id: "12", name: "12 Months", value: 12 },
    { id: "13", name: "13 Months", value: 13 },
    { id: "14", name: "14 Months", value: 14 },
    { id: "15", name: "15 Months", value: 15 },
    { id: "16", name: "16 Months", value: 16 },
    { id: "17", name: "17 Months", value: 17 },
    { id: "18", name: "18 Months", value: 18 },
    { id: "19", name: "19 Months", value: 19 },
    { id: "20", name: "20 Months", value: 20 },
    { id: "21", name: "21 Months", value: 21 },
    { id: "22", name: "22 Months", value: 22 },
    { id: "23", name: "23 Months", value: 23 },
    { id: "24", name: "24 Months", value: 24 },
    { id: "25", name: "25 Months", value: 25 },
    { id: "26", name: "26 Months", value: 26 },
    { id: "27", name: "27 Months", value: 27 },
    { id: "28", name: "28 Months", value: 28 },
    { id: "29", name: "29 Months", value: 29 },
    { id: "30", name: "30 Months", value: 30 },
    { id: "31", name: "31 Months", value: 31 },
    { id: "32", name: "32 Months", value: 32 },
    { id: "33", name: "33 Months", value: 33 },
    { id: "34", name: "34 Months", value: 34 },
    { id: "35", name: "35 Months", value: 35 },
    { id: "36", name: "36 Months", value: 36 },
  ]

  // Number of Resources 100
  const numberOfResourcesOptions = [
    { id: "1", name: "1", value: 1 },
    { id: "2", name: "2", value: 2 },
    { id: "3", name: "3", value: 3 },
    { id: "4", name: "4", value: 4 },
    { id: "5", name: "5", value: 5 },
    { id: "6", name: "6", value: 6 },
    { id: "7", name: "7", value: 7 },
    { id: "8", name: "8", value: 8 },
    { id: "9", name: "9", value: 9 },
    { id: "10", name: "10", value: 10 },
    { id: "11", name: "11", value: 11 },
    { id: "12", name: "12", value: 12 },
    { id: "13", name: "13", value: 13 },
    { id: "14", name: "14", value: 14 },
    { id: "15", name: "15", value: 15 },
    { id: "16", name: "16", value: 16 },
    { id: "17", name: "17", value: 17 },
    { id: "18", name: "18", value: 18 },
    { id: "19", name: "19", value: 19 },
    { id: "20", name: "20", value: 20 },
    { id: "21", name: "21", value: 21 },
    { id: "22", name: "22", value: 22 },
    { id: "23", name: "23", value: 23 },
    { id: "24", name: "24", value: 24 },
    { id: "25", name: "25", value: 25 },
    { id: "26", name: "26", value: 26 },
    { id: "27", name: "27", value: 27 },
    { id: "28", name: "28", value: 28 },
    { id: "29", name: "29", value: 29 },
    { id: "30", name: "30", value: 30 },
    { id: "31", name: "31", value: 31 },
    { id: "32", name: "32", value: 32 },
    { id: "33", name: "33", value: 33 },
    { id: "34", name: "34", value: 34 },
    { id: "35", name: "35", value: 35 },
    { id: "36", name: "36", value: 36 },
    { id: "37", name: "37", value: 37 },
    { id: "38", name: "38", value: 38 },
    { id: "39", name: "39", value: 39 },
    { id: "40", name: "40", value: 40 },
    { id: "41", name: "41", value: 41 },
    { id: "42", name: "42", value: 42 },
    { id: "43", name: "43", value: 43 },
    { id: "44", name: "44", value: 44 },
    { id: "45", name: "45", value: 45 },
    { id: "46", name: "46", value: 46 },
    { id: "47", name: "47", value: 47 },
    { id: "48", name: "48", value: 48 },
    { id: "49", name: "49", value: 49 },
    { id: "50", name: "50", value: 50 },
    { id: "51", name: "51", value: 51 },
    { id: "52", name: "52", value: 52 },
    { id: "53", name: "53", value: 53 },
    { id: "54", name: "54", value: 54 },
    { id: "55", name: "55", value: 55 },
    { id: "56", name: "56", value: 56 },
    { id: "57", name: "57", value: 57 },
    { id: "58", name: "58", value: 58 },
    { id: "59", name: "59", value: 59 },
    { id: "60", name: "60", value: 60 },
    { id: "61", name: "61", value: 61 },
    { id: "62", name: "62", value: 62 },
    { id: "63", name: "63", value: 63 },
    { id: "64", name: "64", value: 64 },
    { id: "65", name: "65", value: 65 },
    { id: "66", name: "66", value: 66 },
    { id: "67", name: "67", value: 67 },
    { id: "68", name: "68", value: 68 },
    { id: "69", name: "69", value: 69 },
    { id: "70", name: "70", value: 70 },
    { id: "71", name: "71", value: 71 },
    { id: "72", name: "72", value: 72 },
    { id: "73", name: "73", value: 73 },
    { id: "74", name: "74", value: 74 },
    { id: "75", name: "75", value: 75 },
    { id: "76", name: "76", value: 76 },
    { id: "77", name: "77", value: 77 },
    { id: "78", name: "78", value: 78 },
    { id: "79", name: "79", value: 79 },
    { id: "80", name: "80", value: 80 },
    { id: "81", name: "81", value: 81 },
    { id: "82", name: "82", value: 82 },
    { id: "83", name: "83", value: 83 },
    { id: "84", name: "84", value: 84 },
    { id: "85", name: "85", value: 85 },
    { id: "86", name: "86", value: 86 },
    { id: "87", name: "87", value: 87 },
    { id: "88", name: "88", value: 88 },
    { id: "89", name: "89", value: 89 },
    { id: "90", name: "90", value: 90 },
    { id: "91", name: "91", value: 91 },
    { id: "92", name: "92", value: 92 },
    { id: "93", name: "93", value: 93 },
    { id: "94", name: "94", value: 94 },
    { id: "95", name: "95", value: 95 },
    { id: "96", name: "96", value: 96 },
    { id: "97", name: "97", value: 97 },
    { id: "98", name: "98", value: 98 },
    { id: "99", name: "99", value: 99 },
    { id: "100", name: "100", value: 100 },
  ]

  const resourcesCategoryOptions = [
    { id: "1", name: "UI UX & Product Designer", price: 5000 },
    { id: "2", name: "Front-End Developer", price: 5000 },
    { id: "3", name: "Back-End Developer", price: 5000 },
    { id: "4", name: "Full-Stack Developer", price: 5000 },
    { id: "5", name: "Mobile Apps Developer", price: 5000 },
    { id: "6", name: "Data Science & Machine Learning Stacks", price: 5000 },
    { id: "7", name: "Specialized Stacks", price: 5000 },
  ]

  // Function to calculate total price
  const calculateTotalPrice = (type: "senior" | "midLevel") => {
    const { duration, resourcesCategory } = selectedItems[type]

    const durationValue =
      durationOptions.find((item) => item.name === duration)?.value || 1

    // Define fixed prices per resource type
    const pricePerResource = type === "senior" ? 5600 : 4800

    // Calculate total price
    const total = resourcesCategory.length * pricePerResource * durationValue

    return total
  }

  const handleRadioSelect = (value: "senior" | "mid-level" | "both") => {
    setSelected(value)
  }

  const handleCategorySelect = (id: string[], type: "senior" | "midLevel") => {
    setSelectedItems((prev) => {
      const selectedCategories = resourcesCategoryOptions.filter((item) =>
        id.includes(item.id)
      )

      // Calculate updated total price based on new selection
      let total = 0
      let durationValue = 0
      if (type === "senior") {
        durationValue =
          durationOptions.find((item) => item.name === prev[type].duration)
            ?.value || 1
        total = selectedCategories.reduce((sum, item) => sum + 5600, 0)
      } else {
        durationValue =
          durationOptions.find((item) => item.name === prev[type].duration)
            ?.value || 1
        total = selectedCategories.reduce((sum, item) => sum + 4800, 0)
      }

      return {
        ...prev,
        [type]: {
          ...prev[type],
          resourcesCategory: selectedCategories,
          totalPrice: total * durationValue, // Correct calculation
        },
      }
    })
  }

  const handleRemoveCategory = (id: string, type: "senior" | "midLevel") => {
    setSelectedItems((prev) => {
      const updatedCategories = prev[type].resourcesCategory.filter(
        (item) => item.id !== id
      )

      // Calculate updated total price
      let durationValue = 0
      let total = 0
      if (type === "senior") {
        durationValue =
          durationOptions.find((item) => item.name === prev[type].duration)
            ?.value || 1
        total = updatedCategories.reduce(
          (sum, item) =>
            sum +
            ((resourcesCategoryOptions.find((opt) => opt.id === item.id) &&
              5600) ||
              0),
          0
        )
      } else {
        durationValue =
          durationOptions.find((item) => item.name === prev[type].duration)
            ?.value || 1
        total = updatedCategories.reduce(
          (sum, item) =>
            sum +
            ((resourcesCategoryOptions.find((opt) => opt.id === item.id) &&
              4800) ||
              0),
          0
        )
      }

      return {
        ...prev,
        [type]: {
          ...prev[type],
          resourcesCategory: updatedCategories,
          totalPrice: total * durationValue,
        },
      }
    })
  }

  const handleDurationSelect = (id: string[], type: "senior" | "midLevel") => {
    const selectedDuration = durationOptions.find((item) =>
      id.includes(item.id)
    )

    if (selectedDuration) {
      setSelectedItems((prev) => {
        // Calculate updated total price
        let total = 0

        if (type === "senior") {
          total = prev[type].resourcesCategory.reduce(
            (sum, item) =>
              sum +
              ((resourcesCategoryOptions.find((opt) => opt.id === item.id) &&
                5600) ||
                0),
            0
          )
        } else {
          total = prev[type].resourcesCategory.reduce(
            (sum, item) =>
              sum +
              ((resourcesCategoryOptions.find((opt) => opt.id === item.id) &&
                4800) ||
                0),
            0
          )
        }

        return {
          ...prev,
          [type]: {
            ...prev[type],
            duration: selectedDuration.name,
            totalPrice: total * selectedDuration.value, // Correctly updates price
          },
        }
      })
    } else {
      setSelectedItems((prev) => {
        return {
          ...prev,
          [type]: { ...prev[type], duration: "", totalPrice: 0 },
        }
      })
    }
  }

  const handleNumberOfResourcesSelect = (
    id: string[],
    type: "senior" | "midLevel"
  ) => {
    const selectedResource = numberOfResourcesOptions.find((item) =>
      id.includes(item.id)
    )
    if (selectedResource) {
      setSelectedItems((prev) => {
        const updated = {
          ...prev,
          [type]: {
            ...prev[type],
            numberOfResources: selectedResource.name,
          },
        }
        updated[type].totalPrice = calculateTotalPrice(type)
        return updated
      })
    } else {
      setSelectedItems((prev) => {
        return {
          ...prev,
          [type]: { ...prev[type], numberOfResources: "", totalPrice: 0 },
        }
      })
    }
  }

  React.useEffect(() => {
    setSelectedIds(
      selectedItems["midLevel"].resourcesCategory.map((item: any) => item.id)
    )
  }, [selectedItems["midLevel"].resourcesCategory])
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <>
      <div className="relative lg:bottom-16 lg:mt-0 lg:py-10 map-b">
        <div className="container mx-auto w-[70%]">
          <p className="lg:text-4xl text-nowrap text-[10px] text-black font-semibold text-center">
            You select the duration of work even <br />
            <span className="text-gradient-secondary">there is no limit.</span>
          </p>
          <div className="lg:my-4 my-2 w-full">
            <p className="text-center text-black lg:text-sm text-[7px]">
              We engage our project managers and engineers with the availability
              of <br /> 24/7 and they work with your time zone.
            </p>
          </div>
          <div className="lg:my-4 my-2 w-full">
            <p className="text-center text-black font-semibold lg:text-lg text-[7px]">
              Choose a <span className="text-[#7B68EC]">Plan</span> that’s Right
              for you!
            </p>
          </div>

          <div>
            {/* Buttons */}
            <div className="flex gap-2 justify-center pt-5">
              <button
                onClick={() => handleRadioSelect("senior")}
                className={classNames(
                  "px-4 py-3 font-inter text-black real-time-quote-radius lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded bg-btn bg-glass",
                  {
                    "bg-header-unique-btn text-black":
                      selected === "senior" || selected === "both",
                    "bg-gray-300": selected !== "senior" && selected !== "both",
                  }
                )}
              >
                Senior Resource
              </button>
              <button
                onClick={() => handleRadioSelect("mid-level")}
                className={classNames(
                  "px-4 py-3 font-inter text-black lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded bg-btn bg-glass book-free-consultancy-radius",
                  {
                    "bg-header-unique-btn text-black":
                      selected === "mid-level" || selected === "both",
                    "bg-gray-300":
                      selected !== "mid-level" && selected !== "both",
                  }
                )}
              >
                Mid-Level Resource
              </button>
            </div>

            {/* Radio-like Selection */}
            <div className="flex justify-center gap-3 pt-10">
              {["senior", "mid-level", "both"].map((type) => (
                <div
                  key={type}
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={() =>
                    handleRadioSelect(type as "senior" | "mid-level" | "both")
                  }
                >
                  <div className="w-5 h-5 relative rounded-full border-linear-gradient bg-transparent">
                    {selected === type && (
                      <div className="bg-header-unique-btn h-3 w-3 absolute top-1 left-1 rounded-full"></div>
                    )}
                  </div>
                  <p className="text-black font-semibold capitalize  text-xs lg:text-sm">
                    {type}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* senior-plan */}
        {(selected === "senior" || selected === "both") && (
          <div
            className={` py-10 container mx-auto rounded-xl shadow-lg mt-5 ${theme == "glassy" ? "" : theme === "light" ? "bg-completedProject" : theme === "dark" ? "bg-[#2D31353D] backdrop-blur-xl" : "bg-[#FFFFFF3D] backdrop-blur-sm"}`}
          >
            <div className="">
              <p className="lg:text-5xl text-nowrap text-[14px] text-black text-center">
                Custom Selection Upon Your Need
              </p>
              <p className="text-black text-center lg:text-lg text-sm pt-3">
                <span className="text-[#7B68EC] font-semibold text-5xl">
                  $5,600
                </span>{" "}
                Per month (for one resource)
              </p>
              <div className="lg:mx-10 mx-3 pt-8">
                <div className="flex lg:flex-row md:flex-row flex-col justify-between">
                  <div className="lg:w-[40%] w-full relative">
                    {theme == "glassy" ? (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    ) : theme === "light" ? (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg-light.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    ) : theme === "dark" ? (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg-dark.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    ) : (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    )}
                    <div className="absolute top-[10%] left-0 w-full h-full px-2">
                      <div className="flex flex-col items-center justify-center">
                        <StaticImage
                          className="mx-3 w-14 lg:mx-0"
                          src="./resource.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                        <p className="text-black capitalize font-semibold text-sm mt-2">
                          Senior Resource
                        </p>
                      </div>
                      {/* duration */}
                      <div className="flex gap-2 items-center px-4 pt-5">
                        {/* watch-svg */}
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.7099 15.1798L12.6099 13.3298C12.0699 13.0098 11.6299 12.2398 11.6299 11.6098V7.50977"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <p className="text-black text-lg">
                          Duration of the job:{" "}
                          {selectedItems["senior"].duration.split(" ")[0]}{" "}
                          <span className="text-[#6E5DD1] text-sm">
                            {selectedItems["senior"].duration.split(" ")[1]}
                          </span>
                        </p>
                      </div>
                      {/* Resource */}
                      <div className="flex gap-2 items-center px-4 pt-3">
                        {/* profile-svg */}
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9.16055 10.87C9.06055 10.86 8.94055 10.86 8.83055 10.87C6.45055 10.79 4.56055 8.84 4.56055 6.44C4.56055 3.99 6.54055 2 9.00055 2C11.4505 2 13.4405 3.99 13.4405 6.44C13.4305 8.84 11.5405 10.79 9.16055 10.87Z"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M16.4093 4C18.3493 4 19.9093 5.57 19.9093 7.5C19.9093 9.39 18.4093 10.93 16.5393 11C16.4593 10.99 16.3693 10.99 16.2793 11"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4.1607 14.56C1.7407 16.18 1.7407 18.82 4.1607 20.43C6.9107 22.27 11.4207 22.27 14.1707 20.43C16.5907 18.81 16.5907 16.17 14.1707 14.56C11.4307 12.73 6.9207 12.73 4.1607 14.56Z"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <p className="text-black text-lg">
                          Number of Resources:{" "}
                          {selectedItems &&
                            selectedItems["senior"].numberOfResources}{" "}
                        </p>
                      </div>
                      {/* selected-category */}
                      <div className="pl-12 pt-3 h-[20%]">
                        <p className="text-black text-lg font-semibold">
                          Selected Category:
                        </p>
                        <div className="flex pt-2 gap-2 flex-wrap">
                          {selectedItems["senior"]?.resourcesCategory[0]
                            ?.name !== "" &&
                            selectedItems["senior"].resourcesCategory?.map(
                              (item: any) => (
                                <div className="flex gap-2 cursor-pointer items-center bg-[#B7B0DF] rounded-xl px-3 py-2 cross-parent">
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8.603 3.799C9.02496 3.31223 9.54673 2.92196 10.1329 2.65468C10.719 2.38741 11.3558 2.24939 12 2.25C13.357 2.25 14.573 2.85 15.397 3.799C16.0397 3.75311 16.6847 3.84609 17.2883 4.07161C17.8919 4.29713 18.4399 4.64992 18.895 5.106C19.3509 5.56106 19.7036 6.10888 19.9291 6.71226C20.1546 7.31564 20.2477 7.96047 20.202 8.603C20.6886 9.02505 21.0787 9.54686 21.3458 10.133C21.6129 10.7191 21.7507 11.3559 21.75 12C21.7506 12.6442 21.6126 13.281 21.3453 13.8671C21.078 14.4533 20.6878 14.975 20.201 15.397C20.2467 16.0395 20.1536 16.6844 19.9281 17.2877C19.7026 17.8911 19.3499 18.4389 18.894 18.894C18.4389 19.3499 17.8911 19.7026 17.2877 19.9281C16.6844 20.1536 16.0395 20.2467 15.397 20.201C14.975 20.6878 14.4533 21.078 13.8671 21.3453C13.281 21.6126 12.6442 21.7506 12 21.75C11.3558 21.7506 10.719 21.6126 10.1329 21.3453C9.54673 21.078 9.02496 20.6878 8.603 20.201C7.96038 20.247 7.31538 20.1542 6.71181 19.9289C6.10824 19.7035 5.56023 19.3509 5.105 18.895C4.64897 18.4398 4.29622 17.8919 4.0707 17.2883C3.84518 16.6847 3.75218 16.0397 3.798 15.397C3.31141 14.9749 2.92133 14.4531 2.65423 13.867C2.38713 13.2809 2.24927 12.6441 2.25 12C2.25 10.643 2.85 9.427 3.799 8.603C3.75326 7.96047 3.8463 7.31562 4.07182 6.71222C4.29734 6.10883 4.65005 5.56103 5.106 5.106C5.56103 4.65005 6.10883 4.29734 6.71222 4.07182C7.31562 3.8463 7.96047 3.75326 8.603 3.799ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62136C15.7361 9.52257 15.7013 9.42783 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98222 14.9769 8.97992 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27226 12.5612 8.26883 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
                                        fill="#6E5DD1"
                                      />
                                    </svg>
                                  </div>
                                  <p className="text-[#6E5DD1] text-sm">
                                    {item.name}
                                  </p>
                                  <div
                                    onClick={() =>
                                      handleRemoveCategory(item.id, "senior")
                                    }
                                    className="rounded-full cross h-5 w-5 bg-[#C6C1E6] hover:opacity-50 flex justify-center hidden items-center"
                                  >
                                    <p className="text-sm text-[#6E5DD1]">X</p>
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                      {/* Total Amount */}
                      <div className="pt-10">
                        <p className="text-center text-black">
                          <span className="text-[#6E5DD1] text-5xl font-semibold">
                            {selectedItems["senior"].totalPrice > 0
                              ? "$" + selectedItems["senior"].totalPrice
                              : "$---"}{" "}
                          </span>{" "}
                          Total
                        </p>
                        <p className="text-black text-center font-semibold pt-3">
                          You Will Pay Every Month{" "}
                          {selectedItems["senior"].totalPrice > 0
                            ? "$" + selectedItems["senior"].totalPrice
                            : "$---"}{" "}
                        </p>
                      </div>
                      {/* lets-discuss */}
                      <div className="flex justify-center lg:mt-4 mt-2 px-5">
                        <div className=" border w-fit border-with-theme py-3 px-3 relative">
                          <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] left-[-4px]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] left-[50%]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] right-[-4px]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] left-[-4px]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] left-[50%]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] right-[-4px]"></div>
                          <p className="text-center text-black lg:text-2xl text-[7px]">
                            Let’s Discuss In The Call About <br /> The Resource
                            You Need
                          </p>
                        </div>
                      </div>
                      <div className="px-4 pt-10">
                        <p className="text-center text-sm text-black opacity-60">
                          You’ll get {selectedItems["senior"].numberOfResources}{" "}
                          senior resource as per your required <br /> niche and
                          visual folio project manager for <br /> your work for
                          the{" "}
                          {selectedItems["senior"]?.duration
                            ? selectedItems["senior"]?.duration
                            : "--"}
                          !
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="lg:w-[55%] w-full lg:mt-0 mt-5">
                    <div className="flex flex-wrap">
                      <div className="w-1/2 px-2">
                        <Dropdown
                          id="duration"
                          title="Select the duration of the job"
                          data={durationOptions}
                          style="bg-purple"
                          type="senior"
                          selectedIds={selectedIds}
                          onSelect={handleDurationSelect}
                        />
                      </div>
                      <div className="w-1/2 px-2">
                        <Dropdown
                          id="Resources"
                          title="Select the Numbers of Resources"
                          data={numberOfResourcesOptions}
                          style="bg-purple"
                          type="senior"
                          selectedIds={selectedIds}
                          onSelect={handleNumberOfResourcesSelect}
                        />
                      </div>
                      <div className="w-full pt-4 px-2">
                        <Dropdown
                          id="category"
                          title="Select the resource Category/stack/type"
                          data={resourcesCategoryOptions}
                          style="bg-purple"
                          isMultiSelect={true}
                          selectedIds={selectedIds}
                          type="senior"
                          onSelect={handleCategorySelect}
                        />
                      </div>
                    </div>
                    {/* Benefits For You */}
                    <div className="pt-5 px-3">
                      <p className="text-[#6E5DD1] font-semibold">
                        Benefits For You
                      </p>
                      <div className="flex gap-2 items-center pt-3">
                        <div>
                          <StaticImage
                            className="w-6 h-6"
                            src="./developer.png"
                            alt="benefit-icon"
                            placeholder="blurred"
                          />
                        </div>
                        <p className="text-black text-sm">
                          Senior Resource Engineer/Developer/Designer{" "}
                          <span className="text-[#6E5DD1]">
                            (any of the category as per your need)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <div>
                          <StaticImage
                            className="w-6 h-6"
                            src="./project-manager.png"
                            alt="benefit-icon"
                            placeholder="blurred"
                          />
                        </div>
                        <p className="text-black text-sm">Project Manager</p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <div>
                          <StaticImage
                            className="w-6 h-6"
                            src="./clock.png"
                            alt="benefit-icon"
                            placeholder="blurred"
                          />
                        </div>
                        <p className="text-black text-sm">
                          Work With Your Time Zone
                        </p>
                      </div>
                      <div className="w-full h-[1px] bg-white my-6" />
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          $35 per hour{" "}
                          <span className="text-[#6E5DD1]">
                            (for one resource for any category)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Be your Full-time{" "}
                          <span className="text-[#6E5DD1]">
                            (If you need part-time, let’s connect on a call)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          5 working week days{" "}
                          <span className="text-[#6E5DD1]">
                            (8 hours a day)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          8 to 10 Years of Experience
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Team Lead Capabilities
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Daily basis updates on work
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Available for urgent tasks{" "}
                          <span className="text-[#6E5DD1]">
                            (On weekends as well)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Proficiency in English fluency
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Conversational in any language
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Quick response on the tasks & queries
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Any collaborative tool as per your choice (slack,
                          Asana, Jira, Trello)
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Available for the meeting any day and anytime of a
                          week
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Agreed on signing off an NDA/contract
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          We respect your ideas & IP, And never share it with
                          others. Everything is confidential{" "}
                        </p>
                      </div>
                      {selected !== "both" && (
                        <div className="flex justify-center pt-5">
                          {rootElement && (
                            <PopupButton
                              className="px-10 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                              url="https://calendly.com/visualfolio-info/30min"
                              rootElement={rootElement}
                              text="Book a Call"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* middle-plan */}
        {(selected === "mid-level" || selected === "both") && (
          <div
            className={` py-10 container mx-auto rounded-xl shadow-lg mt-5 ${theme == "glassy" ? "" : theme === "light" ? "bg-completedProject" : theme === "dark" ? "bg-[#2D31353D] backdrop-blur-xl" : "bg-[#FFFFFF3D] backdrop-blur-sm"}`}
          >
            <div className="backdrop-blur-lg">
              <p className="lg:text-5xl text-nowrap text-[14px] text-black text-center">
                Custom Selection Upon Your Need
              </p>
              <p className="text-black text-center lg:text-lg text-sm pt-3">
                <span className="text-[#7B68EC] font-semibold text-5xl">
                  $4,800
                </span>{" "}
                Per month (for one resource)
              </p>
              <div className="lg:mx-10 mx-3 pt-8">
                <div className="flex lg:flex-row md:flex-row flex-col justify-between">
                  <div className="lg:w-[40%] w-full relative">
                    {theme == "glassy" ? (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    ) : theme === "light" ? (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg-light.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    ) : theme === "dark" ? (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg-dark.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    ) : (
                      <div>
                        <StaticImage
                          className="mx-3 lg:mx-0"
                          src="./resource-bg.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                      </div>
                    )}
                    <div className="absolute top-[10%] left-0 w-full h-full px-2">
                      <div className="flex flex-col items-center justify-center">
                        <StaticImage
                          className="mx-3 w-14 lg:mx-0"
                          src="./resource.png"
                          alt="resourceHero"
                          placeholder="blurred"
                          layout="fullWidth"
                        />
                        <p className="text-black capitalize font-semibold text-sm mt-2">
                          Mid-level Resource
                        </p>
                      </div>
                      {/* duration */}
                      <div className="flex gap-2 items-center px-4 pt-5">
                        {/* watch-svg */}
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.7099 15.1798L12.6099 13.3298C12.0699 13.0098 11.6299 12.2398 11.6299 11.6098V7.50977"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <p className="text-black text-lg">
                          Duration of the job:{" "}
                          {selectedItems["midLevel"].duration.split(" ")[0]}{" "}
                          <span className="text-[#6E5DD1] text-sm">
                            {selectedItems["midLevel"].duration.split(" ")[1]}
                          </span>
                        </p>
                      </div>
                      {/* Resource */}
                      <div className="flex gap-2 items-center px-4 pt-3">
                        {/* profile-svg */}
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9.16055 10.87C9.06055 10.86 8.94055 10.86 8.83055 10.87C6.45055 10.79 4.56055 8.84 4.56055 6.44C4.56055 3.99 6.54055 2 9.00055 2C11.4505 2 13.4405 3.99 13.4405 6.44C13.4305 8.84 11.5405 10.79 9.16055 10.87Z"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M16.4093 4C18.3493 4 19.9093 5.57 19.9093 7.5C19.9093 9.39 18.4093 10.93 16.5393 11C16.4593 10.99 16.3693 10.99 16.2793 11"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4.1607 14.56C1.7407 16.18 1.7407 18.82 4.1607 20.43C6.9107 22.27 11.4207 22.27 14.1707 20.43C16.5907 18.81 16.5907 16.17 14.1707 14.56C11.4307 12.73 6.9207 12.73 4.1607 14.56Z"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
                              stroke="#6E5DD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <p className="text-black text-lg">
                          Number of Resources:{" "}
                          {selectedItems &&
                            selectedItems["midLevel"].numberOfResources}{" "}
                        </p>
                      </div>
                      {/* selected-category */}
                      <div className="pl-12 pt-3 h-[20%]">
                        <p className="text-black text-lg font-semibold">
                          Selected Category:
                        </p>
                        <div className="flex pt-2 gap-2 flex-wrap">
                          {selectedItems["midLevel"]?.resourcesCategory[0]
                            ?.name !== "" &&
                            selectedItems["midLevel"].resourcesCategory?.map(
                              (item: any) => (
                                <div className="flex gap-2 cursor-pointer items-center bg-[#B7B0DF] rounded-xl px-3 py-2 cross-parent">
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8.603 3.799C9.02496 3.31223 9.54673 2.92196 10.1329 2.65468C10.719 2.38741 11.3558 2.24939 12 2.25C13.357 2.25 14.573 2.85 15.397 3.799C16.0397 3.75311 16.6847 3.84609 17.2883 4.07161C17.8919 4.29713 18.4399 4.64992 18.895 5.106C19.3509 5.56106 19.7036 6.10888 19.9291 6.71226C20.1546 7.31564 20.2477 7.96047 20.202 8.603C20.6886 9.02505 21.0787 9.54686 21.3458 10.133C21.6129 10.7191 21.7507 11.3559 21.75 12C21.7506 12.6442 21.6126 13.281 21.3453 13.8671C21.078 14.4533 20.6878 14.975 20.201 15.397C20.2467 16.0395 20.1536 16.6844 19.9281 17.2877C19.7026 17.8911 19.3499 18.4389 18.894 18.894C18.4389 19.3499 17.8911 19.7026 17.2877 19.9281C16.6844 20.1536 16.0395 20.2467 15.397 20.201C14.975 20.6878 14.4533 21.078 13.8671 21.3453C13.281 21.6126 12.6442 21.7506 12 21.75C11.3558 21.7506 10.719 21.6126 10.1329 21.3453C9.54673 21.078 9.02496 20.6878 8.603 20.201C7.96038 20.247 7.31538 20.1542 6.71181 19.9289C6.10824 19.7035 5.56023 19.3509 5.105 18.895C4.64897 18.4398 4.29622 17.8919 4.0707 17.2883C3.84518 16.6847 3.75218 16.0397 3.798 15.397C3.31141 14.9749 2.92133 14.4531 2.65423 13.867C2.38713 13.2809 2.24927 12.6441 2.25 12C2.25 10.643 2.85 9.427 3.799 8.603C3.75326 7.96047 3.8463 7.31562 4.07182 6.71222C4.29734 6.10883 4.65005 5.56103 5.106 5.106C5.56103 4.65005 6.10883 4.29734 6.71222 4.07182C7.31562 3.8463 7.96047 3.75326 8.603 3.799ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62136C15.7361 9.52257 15.7013 9.42783 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98222 14.9769 8.97992 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27226 12.5612 8.26883 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
                                        fill="#6E5DD1"
                                      />
                                    </svg>
                                  </div>
                                  <p className="text-[#6E5DD1] text-sm">
                                    {item.name}
                                  </p>
                                  <div
                                    onClick={() =>
                                      handleRemoveCategory(item.id, "midLevel")
                                    }
                                    className="rounded-full cross h-5 w-5 bg-[#C6C1E6] hover:opacity-50 flex justify-center hidden items-center"
                                  >
                                    <p className="text-sm text-[#6E5DD1]">X</p>
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                      {/* Total Amount */}
                      <div className="pt-10">
                        <p className="text-center text-black">
                          <span className="text-[#6E5DD1] text-5xl font-semibold">
                            {selectedItems["midLevel"].totalPrice > 0
                              ? "$" + selectedItems["midLevel"].totalPrice
                              : "$---"}{" "}
                          </span>{" "}
                          Total
                        </p>
                        <p className="text-black text-center font-semibold pt-3">
                          You Will Pay Every Month{" "}
                          {selectedItems["midLevel"].totalPrice > 0
                            ? "$" + selectedItems["midLevel"].totalPrice
                            : "$---"}{" "}
                        </p>
                      </div>
                      {/* lets-discuss */}
                      <div className="flex justify-center lg:mt-4 mt-2 px-5">
                        <div className=" border w-fit border-with-theme py-3 px-3 relative">
                          <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] left-[-4px]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] left-[50%]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] right-[-4px]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] left-[-4px]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] left-[50%]"></div>
                          <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] right-[-4px]"></div>
                          <p className="text-center text-black lg:text-2xl text-[7px]">
                            Let’s Discuss In The Call About <br /> The Resource
                            You Need
                          </p>
                        </div>
                      </div>
                      <div className="px-4 pt-10">
                        <p className="text-center text-sm text-black opacity-60">
                          You’ll get{" "}
                          {selectedItems["midLevel"].numberOfResources} senior
                          resource as per your required <br /> niche and visual
                          folio project manager for <br /> your work for the{" "}
                          {selectedItems["midLevel"]?.duration
                            ? selectedItems["midLevel"]?.duration
                            : "--"}
                          !
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="lg:w-[55%] w-full lg:mt-0 mt-5">
                    <div className="flex flex-wrap">
                      <div className="w-1/2 px-2">
                        <Dropdown
                          id="duration1"
                          title="Select the duration of the job"
                          data={durationOptions}
                          style="bg-purple"
                          type="midLevel"
                          onSelect={handleDurationSelect}
                        />
                      </div>
                      <div className="w-1/2 px-2">
                        <Dropdown
                          id="Resources2"
                          title="Select the Numbers of Resources"
                          data={numberOfResourcesOptions}
                          style="bg-purple"
                          type="midLevel"
                          onSelect={handleNumberOfResourcesSelect}
                        />
                      </div>
                      <div className="w-full pt-4 px-2">
                        <Dropdown
                          id="category2"
                          title="Select the resource Category/stack/type"
                          data={resourcesCategoryOptions}
                          style="bg-purple"
                          isMultiSelect={true}
                          selectedIds={selectedIds}
                          type="midLevel"
                          onSelect={handleCategorySelect}
                        />
                      </div>
                    </div>
                    {/* Benefits For You */}
                    <div className="pt-5 px-3">
                      <p className="text-[#6E5DD1] font-semibold">
                        Benefits For You
                      </p>
                      <div className="flex gap-2 items-center pt-3">
                        <div>
                          <StaticImage
                            className="w-6 h-6"
                            src="./developer.png"
                            alt="benefit-icon"
                            placeholder="blurred"
                          />
                        </div>
                        <p className="text-black text-sm">
                          Senior Resource Engineer/Developer/Designer{" "}
                          <span className="text-[#6E5DD1]">
                            (any of the category as per your need)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <div>
                          <StaticImage
                            className="w-6 h-6"
                            src="./project-manager.png"
                            alt="benefit-icon"
                            placeholder="blurred"
                          />
                        </div>
                        <p className="text-black text-sm">Project Manager</p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <div>
                          <StaticImage
                            className="w-6 h-6"
                            src="./clock.png"
                            alt="benefit-icon"
                            placeholder="blurred"
                          />
                        </div>
                        <p className="text-black text-sm">
                          Work With Your Time Zone
                        </p>
                      </div>
                      <div className="w-full h-[1px] bg-white my-6" />
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          $30 per hour{" "}
                          <span className="text-[#6E5DD1]">
                            (for one resource for any category)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Be your Full-time{" "}
                          <span className="text-[#6E5DD1]">
                            (If you need part-time, let’s connect on a call)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          5 working week days{" "}
                          <span className="text-[#6E5DD1]">
                            (8 hours a day)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          3 to 5 Years of Experience
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Daily basis updates on work
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Available for urgent tasks{" "}
                          <span className="text-[#6E5DD1]">
                            (On weekends as well)
                          </span>
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Proficiency in English fluency
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Conversational in any language
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Quick response on the tasks & queries
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Any collaborative tool as per your choice (slack,
                          Asana, Jira, Trello)
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Available for the meeting any day and anytime of a
                          week
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          Agreed on signing off an NDA/contract
                        </p>
                      </div>
                      <div className="flex gap-2 items-center pt-3">
                        <StaticImage
                          className="w-4 h-4"
                          src="./tick.png"
                          alt="benefit-icon"
                          placeholder="blurred"
                        />
                        <p className="text-black text-sm">
                          We respect your ideas & IP, And never share it with
                          others. Everything is confidential{" "}
                        </p>
                      </div>
                      {selected !== "both" && (
                        <div className="flex justify-center pt-5">
                          {rootElement && (
                            <PopupButton
                              className="px-10 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                              url="https://calendly.com/visualfolio-info/30min"
                              rootElement={
                                document.getElementById("___gatsby")!
                              }
                              text="Book a Call"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {selected === "both" && (
          <div className="flex justify-center pt-10">
            {rootElement && (
              <PopupButton
                className="px-10 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                url="https://calendly.com/visualfolio-info/30min"
                rootElement={rootElement}
                text="Book a Call for the both Resource"
              />
            )}
          </div>
        )}
        {/*  */}
      </div>
    </>
  )
}
